class GroupController {
  constructor() {
    this.name = 'group';
  }
}

export default GroupController;



// WEBPACK FOOTER //
// ./client/app/components/group/group.controller.js